import { SavingsFundsRequestsListItem } from '@Common/types/bo/b2b/savings_funds_requests';

export const savingsFundsRequestsTranslations = {
  fields: {
    id: 'Fund Request ID',
    b2b_company_id: 'Company ID',
    number_of_eligible_employees: 'Number of eligible employees',
    date: 'Date',
    total_gross_amount: 'Total gross amount',
    total_net_amount: 'Total net amount to be paid',
    currency: 'Currency',
    created_at: 'Created',
    updated_at: 'Updated',
    status: 'Status',
    type: 'Type',
    recon_status: 'Reconciliation status',
  } satisfies Record<keyof SavingsFundsRequestsListItem, string>,
  actions: {
    edit: {
      success: 'Action sent',
      failure: 'Error sending action: %{error}',
      labels: {
        paid: 'Mark as Paid',
        completed: 'Mark as Completed',
      },
    },
  },
};
